export default __webpack_public_path__ + "static/game-development-img-aaaeff4100e30c187bcd2e8d254bd477.webp";